import { useEffect, useState } from "react";
import firebase from "firebase/app";
import "firebase/firestore";
import Store from "../../types/Store";
import DB_PATH from "../DB_PATH";
import { firestore } from "../firebase";
import Event from "../../types/Event";
import formatDate from "../../utils/fomat/formatDate";

export type StoreResponse = {
  loading: boolean;
  error: boolean;
  events: Event[];
};

export default ({ communityId }: { communityId?: string }): StoreResponse => {
  const [eventsResponse, seteventsResponse] = useState<StoreResponse>({
    loading: true,
    error: false,
    events: [],
  });

  useEffect(() => {
    const eventsCollection = firestore.collection(DB_PATH.EVENT);
    const eventsQuery = communityId
      ? eventsCollection.where("communityId", "==", communityId)
      : eventsCollection;

    // Subscribe to real-time updates
    const unsubscribe = eventsQuery.onSnapshot(
      (querySnapshot) => {
        const events = querySnapshot.docs.map((doc) => {
          const data = doc.data() as Event;

          // Format the `startTime` field if it exists

          return data;
        });

        seteventsResponse({
          loading: false,
          error: false,
          events,
        });
      },
      (error) => {
        console.error("Error fetching events:", error);
        seteventsResponse((prevState) => ({
          ...prevState,
          loading: false,
          error: true,
        }));
      }
    );

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [communityId]);

  return eventsResponse;
};
